// extracted by mini-css-extract-plugin
export var entityChip = "_sb-0";
export var entityChipMissing = "_sb-1";